"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mixpanel = void 0;
var mixpanel_browser_1 = __importDefault(require("mixpanel-browser"));
mixpanel_browser_1.default.init('625bec61fe419afb9eca429679d7a58e');
var actions = {
    identify: function (id) {
        mixpanel_browser_1.default.identify(id);
    },
    alias: function (id) {
        mixpanel_browser_1.default.alias(id);
    },
    track: function (name, props) {
        mixpanel_browser_1.default.track(name, props);
    },
    people: {
        set: function (props) {
            mixpanel_browser_1.default.people.set(props);
        },
    },
};
exports.Mixpanel = actions;
